module.exports = __webpack_public_path__ + "static/media/Collection_1.a9930c5f.jpg";